const AUTH_TOKEN = "token";
const SYSTEM = "system";

export default {
    getAuthToken() {
        if (localStorage.getItem(AUTH_TOKEN) === null || localStorage.getItem(AUTH_TOKEN) === 'null' || localStorage.getItem(AUTH_TOKEN) === "") {
            return null;
        }

        return localStorage.getItem(AUTH_TOKEN);
    },
    setAuthToken(token) {
        localStorage.setItem(AUTH_TOKEN, token);
    },
    getSystem() {
        if (localStorage.getItem(SYSTEM) == null || localStorage.getItem(SYSTEM) == 'null' || localStorage.getItem(SYSTEM) === '') {
            return {};
        }

        return JSON.parse(localStorage.getItem(SYSTEM));
    },
    setSystem(system) {
        localStorage.setItem(SYSTEM, JSON.stringify(system));
    }
};
